import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
}
export function CTAButton({
  children,
  onClick,
  href,
  className = ''
}: CTAButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
    if (href) {
      window.open(href, '_blank', 'noopener,noreferrer');
    } else if (!onClick) {
      // Default behavior: scroll to offer section
      document.getElementById('offer-cta')?.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <div className={`flex flex-col items-center ${className}`} data-id="element-111">
      <button onClick={handleClick} className="bg-gold hover:bg-gold-hover text-navy font-semibold text-lg md:text-xl py-4 px-8 md:px-12 rounded-full transition-all duration-300 shadow-[0_4px_20px_rgba(196,163,90,0.3)] hover:shadow-[0_6px_25px_rgba(196,163,90,0.4)] hover:-translate-y-1" data-id="element-112">
        {children}
      </button>
      <span className="text-sm text-navy/60 mt-3 font-medium flex items-center gap-2" data-id="element-113">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-114">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2" data-id="element-115"></rect>
          <path d="M7 11V7a5 5 0 0 1 10 0v4" data-id="element-116"></path>
        </svg>
        Pago seguro y descarga inmediata
      </span>
    </div>;
}